import { LoadingButton } from "@mui/lab";

export default function LoadingMuiButton({
  text,
  loading,
}: {
  text: string;
  loading: boolean;
}) {
  return (
    <LoadingButton
      variant="contained"
      sx={{
        padding: "10.5px 15.5px",
        width: "66px",
        height: "37px",
        backgroundColor: "#4d4e4e",
        borderRadius: "40px",
        fontSize: "16px",
        letterSpacing: "0.05em",
        color: "#ffffff",
      }}
      loading={loading}
      type="submit"
      children={text}
    />
  );
}
